import type { Locale } from '@kidshub/contracts';

/**
 * Uppercases a family's own words correctly.
 *
 * Turkish has two `i` pairs and the default uppercase mapping gets one of them
 * wrong: `"ilayda"` becomes `"ILAYDA"` rather than `"İLAYDA"`. On a screen full
 * of a family's own names, that is wrong in the primary market every time.
 *
 * `toLocaleUpperCase('tr')` also solves it, but only where the engine ships a
 * full ICU. `ı → I` and `İ → İ` are already correct by default, so only `i`
 * needs redirecting.
 *
 * The Kids App carries the same rule for the same reason. Two copies of one
 * rule is a defect waiting to happen; the shared home for it is either
 * `@kidshub/contracts` or a new shared package, and both are track A's call.
 */
export const toUpperCase = (value: string, locale: Locale): string =>
  locale === 'tr' ? value.replaceAll('i', 'İ').toUpperCase() : value.toUpperCase();

/** The single letter shown in an avatar tile. */
export const toInitial = (value: string, locale: Locale): string =>
  toUpperCase(value.trim().slice(0, 1), locale);
